import Input from "@/components/forms/Input";
import Select from "@/components/forms/Select";
import { useFormik, FormikProvider } from "formik";
import { Dialog } from "primereact/dialog";
import React from "react";
import { Button } from "primereact/button";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { InputSwitch } from "primereact/inputswitch";

interface Props {
  show: boolean;
  onHide: () => void;
  product: any;
}

interface IProduct {
  name: string;
  assigned_traceability: string;
  active: boolean;
}

export default function CreateEditProduct({ show, onHide, product }: Props) {
  const isUpdate = product.id ? true : false;
  const [loading, setLoading] = React.useState(false);
  const options = [
    {
      name: "Product Trace 1",
      value : "Product Trace 1"
    },
    {
      name: "Product Trace 2",
      value : "Product Trace 2"
    },
    {
      name: "Product Trace 3",
      value : "Product Trace 3"
    },
  ];

  const data = {
    name: product?.name,
    assigned_traceability: product?.assigned_traceability,
    active: product.active,
  };

  const formik = useFormik({
    initialValues: {
      name: data.name ?? "",
      assigned_traceability: data.assigned_traceability ?? "",
      active: data.active ?? "",
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      name: Yup.string().required("Required"),
      assigned_traceability: Yup.string().required("Required"),
    }),
    onSubmit: (values: IProduct) => {
      if (isUpdate) {
        // simulate api call
        setLoading(true);
        setTimeout(() => {
          setLoading(false);
          onHide();
          toast.success(
            `Product ${isUpdate ? "Updated" : "Added"} Successfully`
          );
        }, 500);
      } else {
        // simulate api call
        setLoading(true);
        setTimeout(() => {
          setLoading(false);
          onHide();
          toast.success(
            `Product ${isUpdate ? "Updated" : "Added"} Successfully`
          );
        }, 500);
      }
    },
  });

  const { handleSubmit } = formik;

  return (
    <Dialog
      header={isUpdate ? "Edit Product" : "Add Product"}
      visible={show}
      onHide={onHide}
      style={{ width: "50vw" }}
      breakpoints={{ "960px": "75vw", "641px": "100vw" }}
      blockScroll={true}
    >
      <FormikProvider value={formik}>
        <div className="flex flex-column gap-4">
          <Input
            id="name"
            placeholder="eg. Cashew"
            label="Product Name"
            isRequired
          />

          <Select
            id="assigned_traceability"
            label="Assigned Traceability Flow"
            isRequired
            options={options}
            optionLabel="name"
          />

          <section className="flex flex-row gap-4">
            <span>Mark as active</span>

            <InputSwitch
              checked={formik.values.active}
              onChange={(e) => formik.setFieldValue("active", e.value)}
            />
          </section>

          <Button
            label={isUpdate ? "Update User" : "Add User"}
            className="text-white mt-5"
            loading={loading}
            onClick={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
          />
        </div>
      </FormikProvider>
    </Dialog>
  );
}
